import React from 'react';
import './Poll.scss';

function Q3AnswerCopy({ pollQuestions }) {
  return (
    <p className="poll__question">
      Sleep has been shown to be disrupted in up to 60% of children with AD. Adult patients with AD
      have significantly increased fatigue, daytime sleepiness and insomnia.
    </p>
  );
}

export default Q3AnswerCopy;
